<template>
  <div class="tableArea">
    <el-form
      :inline="true"
      :model="formInline"
      class="smallInlineForm"
      v-if="
        tableConfig.form != null ||
        tableConfig.form != {} ||
        tableConfig.form != undefined
      "
    >
      <el-form-item
        v-for="(item, index) in tableConfig.form.params"
        :key="index + item.model"
      >
        <el-input
          v-if="item.type == 'input'"
          v-model="formInline[item.model]"
          :placeholder="$t(item.placeholder)"
        ></el-input>
        <el-select
          v-if="item.type == 'select'"
          default-first-option=""
          v-model="formInline[item.model]"
          :placeholder="$t(item.placeholder)"
        >
          <el-option
            :label="$t(`authorization.resource.area1`)"
            value="shanghai"
          ></el-option>
          <el-option
            :label="$t(`authorization.resource.area2`)"
            value="beijing"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-for="(item, index) in tableConfig.form.actions"
        :key="index"
      >
        <el-button
          class="normalBtn"
          v-if="item.type == 'query' && buttonAuth.indexOf(item.auth) > -1"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-search"
          >{{ $t(item.name) }}</el-button
        >
        <el-button
          class="normalBtn"
          v-if="item.type == 'add' && buttonAuth.indexOf(item.auth) > -1"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-plus"
          >{{ $t(item.name) }}</el-button
        >
        <el-button
          class="normalBtn"
          v-if="item.type == 'edit' && buttonAuth.indexOf(item.auth) > -1"
          :class="{ disabledBtn: selectedItems.length == 0 }"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-edit"
          >{{ $t(item.name) }}</el-button
        >
        <el-button
          class="resetBtn"
          v-if="item.type == 'remove' && buttonAuth.indexOf(item.auth) > -1"
          :class="{ disabledBtn: selectedItems.length == 0 }"
          type="danger"
          @click="action(item.event)"
          icon="el-icon-delete"
          >{{ $t(item.name) }}</el-button
        >
        <el-button
          class="normalBtn"
          v-if="
            (item.type == 'connect' || item.type == 'connectResourceGroup') &&
            buttonAuth.indexOf(item.auth) > -1
          "
          :class="{ disabledBtn: selectedItems.length == 0 }"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-paperclip"
          >{{ $t(item.name) }}</el-button
        >
        <el-button
          class="normalBtn"
          v-if="item.type == 'export' && buttonAuth.indexOf(item.auth) > -1"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-download"
          >{{ $t(item.name) }}</el-button
        >
        <!-- <el-button
          class="normalBtn"
          :class="{ disabledBtn: selectedItems.length == 0 }"
          v-if="item.type == 'resourceImport'"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-upload2"
          >{{ $t(item.name) }}</el-button
        > -->
        <el-upload
          v-if="
            item.type == 'resourceImport' && buttonAuth.indexOf(item.auth) > -1
          "
          :headers="headers"
          class="upload-demo"
          ref="upload1"
          action="/api/resource/importResources"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="uploadSucess"
          :on-error="uploadFail"
          :auto-upload="true"
        >
          <el-button icon="el-icon-upload2" slot="trigger" class="normalBtn">{{
            $t(item.name)
          }}</el-button>
          <el-button
            v-if="false"
            style="margin-left: 10px"
            type="success"
            @click="submitUpload"
            >{{ $t(`authorization.resource.upload`) }}</el-button
          >
          <div slot="tip" class="el-upload__tip">
            {{ $t(`authorization.resource.uploadRule`) }}
          </div>
        </el-upload>
        <el-button
          class="normalBtn"
          v-if="
            item.type == 'resourceExport' && buttonAuth.indexOf(item.auth) > -1
          "
          type="primary"
          @click="action(item.event)"
          icon="el-icon-download"
          >{{ $t(item.name) }}</el-button
        >
        <el-button
          class="normalBtn"
          v-if="item.type == 'connectResource'"
          :class="{ disabledBtn: selectedItems.length == 0 }"
          type="primary"
          @click="action(item.event)"
          icon="el-icon-paperclip"
          >{{ $t(item.name) }}</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableList"
      stripe
      ref="multipleTable"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      :height="tableHeight"
       :tree-props="{children: 'childNode'}">
    >
      <el-table-column
        v-if="tableConfig.table.selection"
        type="selection"
        width="55"
        :reserve-selection="true"
      >
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableConfig.table.columns"
        :prop="item.prop"
        :label="$t(item.label)"
        :width="item.width || 'auto'"
        :min-width="item.minWidth || 'auto'"
        :key="index"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="item.prop == 'status' && scope.row.details.status == 'N'"
            >{{ $t(`common.normal`) }}
          </span>
          <span
            v-else-if="item.prop == 'status' && scope.row.details.status == 'F'"
            class="forbidFont"
            >{{ $t(`common.forbid`) }}
          </span>
          <span v-else>{{ scope.row.details[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="
          tableConfig.table.action !== null ||
          tableConfig.table.action !== undefined ||
          tableConfig.table.action != {}
        "
        :label="$t(tableConfig.table.action.name)"
        :width="tableConfig.table.action.width"
        align="center"
      >
        <el-button
          v-for="(button, index) in tableConfig.table.action.buttons"
          type="text"
          :key="index + button.name"
          @click="action(button.name)"
        >
          <span v-if="buttonAuth.indexOf(button.auth) > -1">
            {{ button.name }}</span
          >
        </el-button>
      </el-table-column>
    </el-table>
    <!-- <tree-table :data="tableList" :columns="tableConfig.table.columns" border />  -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageChoices"
      :page-size="pageSize"
      :total="totalCount"
      background
      layout="prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
// import export_json_to_excel from "@/components/excel/export2Excel"
// import treeTable from "./tableArea";
export default {
  props: ["tableConfig", "tableData", "api", "type", "tableHeight"],
  //   components: { treeTable },
  // components: { Drawer, Dialog },
  data() {
    return {
      headers: {
        Authorization:
          "Bearer" + " " + this.$store.state.login.user.access_token,
      },
      true: true,
      false: false,
      selectedItems1: [],
      selectedItems2: [],
      selectedItems3: [],
      selectedItems: [],
      currentPage: 1,
      pageChoices: [10, 20, 50, 100],
      pageSize: 10,
      formInline: {},
    };
  },
  computed: {
    totalCount() {
      return this.tableData.total || 0;
    },
    tableList() {
      return this.tableData.list || [];
    },
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth || [];
    },
  },
  methods: {
    action(event) {
      if (event === "query") {
        this.formInline.currentPage = this.currentPage;
        this.formInline.pageSize = this.pageSize;
        this.$emit("callBackAction", {
          event: event,
          formInline: this.formInline,
          selectedItems: this.selectedItems,
        });
      } else if (event === "resourceExport") {
        let alink = document.createElement("a");
        alink.download = "teamplte.xlsx"; //文件名,大部分浏览器兼容,IE10及以下不兼容
        alink.href =
          "/api/resource/exportResources?Authorization=" +
          this.$store.state.login.user.access_token +
          "&vagueParam=" +
          (this.formInline.inputKey || ""); //创建 url地址
        alink.click(); //自动点击
      } else {
        this.$emit("callBackAction", {
          event: event,
          formInline: this.formInline,
          selectedItems: this.selectedItems,
        });
      }
    },
    handleSelectionChange(val) {
      this.selectedItems = [
        ...val
      ];
      this.$emit("callBackAction", {
        event: "handleSelectionChange",
        formInline: this.formInline,
        selectedItems: this.selectedItems,
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let event = this.tableConfig.form.actions.filter((item) => {
        return item.type === "query";
      });
      this.action(event[0].event);
    },

    //保存选中的数据id,row-key就是要指定一个key标识这一行的数据，可以多页选择，唯一ID
    getRowKey(row) {
      return row.id;
    },
    // submitUpload() {
    //   this.$refs['upload1'].submit();
    // },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    uploadSucess(response, file, fileList) {
      this.$message({
        message: response.msg,
        type: response.code == "AUTH_000000" ? "success" : "error",
      });
      // this.submitUpload();
    },
    uploadFail(response, file, fileList) {
      // this.submitUpload();
      this.$message({
        message: response.msg,
        type: "error",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tableArea {
  height: 100%;
  // padding: 10px;
  background-color: white;
  border-radius: 5px;
  min-height: 100px;
}
::v-deep .upload-demo {
  // width: 85px;
  height: 32px;
  overflow: hidden;
}
.forbidFont {
  color: #feaa09;
}
.childtr {
  float: left;
}
.childtr:first-child {
  margin-left: 110px;
}
::v-deep tbody thead {
  display: none;
}
::v-deep .el-table .el-table {
  padding: 0 !important;
  min-height: 60px !important;
}
</style>
